import React, { useEffect, useState } from 'react'
import { convertMilliSecToDateNew } from '../../utils/ellowutils';
import Styles from "./styles.module.scss";
import { Icon } from '@iconify/react';
import resourceIcon from "../../assets/images/resource_icon.svg";
import levelIcon from "../../assets/images/level_icon.svg";
import timeIcon from "../../assets/images/time_icon.svg";
import calendarIcon from "../../assets/images/calendar_icon.svg";
import billingIcon from "../../assets/images/billing_icon.svg";
import crownIcon from "../../assets/images/crown_icon.svg";
import locationIcon from "../../assets/images/loc-icon.svg";
import Table from '../../compopnents/table/indx'
import { Link } from "react-router-dom";
import FreeField from '../../compopnents/Field/freeField';
import workType from '../../assets/images/work-type.svg'



function AppliedCandidates(props:any) {
 
  const[lossCountNum, setLossCountNum] = useState<string>('')
  const [appliedResources, setAppliedResources] = useState<any>()
  const [jobMetadata, setJobMetadata] = useState<{
    resourceCount: number , experienceRange: {min: number , max: number} , contractDuration : string , contractStartDate: number , minimumBudget: any , maximumBudget: any ,
    billingType: string ,jobRole: {id: number, name: string} , coreSkills:[{skillId: number, skillName: string}] , otherSkills: [{skillId: number, skillName: string}],
    closedCount: number, jobDescription: string, priority: number, jobResponsibilities: string, lossCount: number, jobType: string;
  }>({
    resourceCount: 0, experienceRange: {min: 0 , max: 12}  , contractDuration: "" , contractStartDate: 0 , minimumBudget: 0 , maximumBudget: 0 ,
    billingType: "",jobRole: {id: 0, name: ""} , coreSkills: [{skillId: 0, skillName: ""}] , otherSkills: [{skillId: 0, skillName: ""}],
    closedCount: 0 , jobDescription : "" , priority: 5, jobResponsibilities: '', lossCount: 0, jobType: ''
  })

  useEffect(() => {
  
    if (props.appliedResources) {
      setAppliedResources(props.appliedResources)
      setJobMetadata(props.jobMetadata)
    }
    if (props && props.jobMetadata && props.jobMetadata.lossCount !== 0) {
      setLossCountNum(props.jobMetadata.lossCount)
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.appliedResources, props.jobMetadata])
   
  const lossCount = (event: any) => {
    props.lossCount(event.target.value)
  }

  const countChange = (event: any) => {
    setLossCountNum((event.target.value).replace('-',''))
  }

  return (
    <section className={Styles.dashboardWrapper}>
      { props && props.jobStatus && props.jobStatus === 3 && <div className={Styles.positionbadge}>
        <span>Position Closed</span>
      </div>}
      <div className="content-wrapper-box">
        <div className={Styles.positionhead}>
          <h3 className="headWithLabel">Applied Candidates </h3>
        </div>
        <div className={Styles.appliedList}>
          { appliedResources && appliedResources.length > 0 ?     <section>
            <Table data={appliedResources} jobId={props.jobId} type={'appliedCandidates'} total={appliedResources.length} pageChange={props.pageChange} pageSize={props.pageSize} getAppliedCandidates={props.getAppliedCandidates } />
          </section>  
          : <div className={Styles.noData}>
              <Icon icon="healthicons:i-groups-perspective-crowd-outline" />
              <p><strong>No resources yet!</strong></p>
              <p>No one has been applied for this position.</p>
            </div> }
        </div>
        <h3 className="headWithLabel">
          {jobMetadata && jobMetadata.jobDescription && "Job Description"}
        </h3>
        <p>{jobMetadata && jobMetadata.jobDescription && <p>{props.convert(jobMetadata.jobDescription).split('\n').map((item :any ,i : any) => <p key = {i}>{item}</p>)} </p> }</p>
        <h3 className="headWithLabel">
          {jobMetadata && jobMetadata.jobResponsibilities && "Job Responsiblities" }
        </h3>
        <p>{jobMetadata && jobMetadata.jobResponsibilities && <p>{props.convert(jobMetadata.jobResponsibilities).split('\n').map((item :any ,i : any) => <p key = {i}>{item}</p>)} </p> }</p>
        <div className={Styles.positionInfo}>
          <div className={Styles.positionItem}>
            <h5>Positions</h5>
            <label>Total</label>
            <div>{jobMetadata && jobMetadata.resourceCount && jobMetadata.resourceCount}</div>
          </div>
          <div className={Styles.positionItem}>
            <h5>Total closed</h5>
            <div className={Styles.statusWrap}>
              <div className={Styles.won}>
                <label>Win</label>
                <div className={Styles.active}>{jobMetadata && jobMetadata.closedCount && jobMetadata.closedCount}</div>
              </div>
              <div className={Styles.loss}>
                <label>Loss</label>
                <div className={Styles.close}>
                    <FreeField
                    type='number'
                    onBlur={(e: any) => lossCount(e)}  
                    value={lossCountNum ? lossCountNum : ''}
                    onChange={countChange}
                  />
                </div>
              </div>
            </div>
        </div>
        <div className={Styles.positionItem}>
          <h5>Positions</h5>
          <label>Active</label>
          <div className={Styles.active}>{jobMetadata && Math.floor((jobMetadata.resourceCount)-(jobMetadata.closedCount + jobMetadata.lossCount))}</div>
        </div>
      </div>
        <div className={Styles.jobStatusWrap}>        
        <div className={Styles.jobStatus}>
          <figure>
            <img src={workType} width="18" alt=''/>
          </figure>
          <figcaption>Job Type </figcaption>
          <h2>{jobMetadata && jobMetadata.jobType ? jobMetadata.jobType : 'Not Mentioned'}</h2>
        </div>
        <div className={Styles.jobStatus}>
          <figure>
            <img src={resourceIcon} alt=''/>
          </figure>
          <figcaption>Resources Required</figcaption>
          <h2>{jobMetadata && jobMetadata.resourceCount && jobMetadata.resourceCount}</h2>
        </div>
        <div className={Styles.jobStatus}>
          <figure>
            <img src={levelIcon} alt=''/>{" "}
          </figure>
          <figcaption>Experience Level</figcaption>
          <h2>{jobMetadata && jobMetadata.experienceRange  ?  jobMetadata.experienceRange.min +" - "+ jobMetadata.experienceRange.max +' Years' : 'Not Mentioned'}</h2>
        </div>
        <div className={Styles.jobStatus}>
          <figure>
            <img src={timeIcon} alt=''/>
          </figure>
          <figcaption>Contract Duration</figcaption>
          <h2>{jobMetadata && jobMetadata.contractDuration !== '' ? jobMetadata.contractDuration : 'Not Mentioned'} </h2>
        </div>
        <div className={Styles.jobStatus}>
          <figure>
            <img src={calendarIcon} alt=''/>
          </figure>
          <figcaption>Start Date</figcaption>
          <h2>{jobMetadata && jobMetadata.contractStartDate !==0 ? convertMilliSecToDateNew(jobMetadata.contractStartDate) : 'Immediate'}</h2>
        </div>
        <div className={Styles.jobStatus}>
          <figure>
            <img src={billingIcon} alt=''/>
          </figure>
          <figcaption>Billing Rates</figcaption>
          <h2>{jobMetadata && jobMetadata.minimumBudget !== '' ? 
                      <h2>{jobMetadata.minimumBudget} ₹ - {jobMetadata.maximumBudget} ₹/ {jobMetadata.billingType}</h2> 
                    : 'Not Mentioned'}
                </h2>
        </div>
        <div className={Styles.jobStatus}>
          <figure>
            <img src={crownIcon} alt=''/>
          </figure>
          <figcaption>Job Role</figcaption>
          <h2>{jobMetadata && jobMetadata.jobRole && jobMetadata.jobRole.name}</h2>
        </div>
        <div className={Styles.jobStatus}> 
          <figure>
          <img src={locationIcon} alt=''/>
          </figure>
          <figcaption>Location</figcaption>
          <h2>
            { props.jobMetadata.locationPreference && props.jobMetadata.locationPreference.location.length > 0 ? 
              props.jobMetadata.locationPreference.location.map((item: any) => {
                return(<Link to="/">{item.name}</Link>)  
              })
              : 'Not Mentioned'
            }
          </h2>  
        </div>
      </div>
      <p>Top 3 skills and expertise most important to the customer</p>
      <div className={Styles.skillsWrap}>
        {jobMetadata && jobMetadata.coreSkills && jobMetadata.coreSkills.map((item : any) =>{
          return(
            <div className={Styles.skillsWrap}>
                <label className={Styles.skills}>{item.skillName}</label>
            </div>
        )})}
      </div>
     { jobMetadata && jobMetadata.otherSkills && jobMetadata.otherSkills.length > 0 && <p>Other skills and expertise</p>}
      <div className={Styles.skillsWrap}>
      {jobMetadata && jobMetadata.otherSkills && jobMetadata.otherSkills.map((item : any) =>{
          return(
            <div className={Styles.skillsWrap}>
                <label className={Styles.skills}>{item.skillName}</label>
            </div>
        )})}
      </div>
    </div>
  </section>
  )
}

export default AppliedCandidates